import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class ArGoodsService extends ApiService {
  template = "defaultTemplate";
  namespace = "service";
  name = "Good";
  icon = "Gear";
  action = "action";
  favicon = "Gear";
  search = true;
  action_lable = this.t("Inactivate");
  inactive = 1;
  Width = 1200;
  DOMAIN = DOMAIN.GOOD;
  singular = this.terminology.good.singular;
  plural = this.terminology.good.plural;
  vowel = this.terminology.good.vowel;
  gemItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.LIST,
    },
    {
      key: "create",
      label: this.t("addAnEntity", { entity: this.singular }),
      icon: AppIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.GEAR,
      field: "display_name",
    },
    {
      header: "Numbers",
      icon: AppIcons.SHRED,
      field: "Number",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this Good...",
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.LIST,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Good",
      icon: AppIcons.LIST,
    },
  ];
  constructor() {
    super("ar-goods");
  }
}
